import { Col, Row } from "reactstrap";
import { SearchPixelStrap } from "../../../../constants";
import { SearchLinkLists } from "../../../../data/applications/SearchResult";
import SearchBanner from "./SearchBanner";
import InformationBlock from "./common/InformationBlock";
import PaginationCard from "./common/PaginationCard";

const AllTabs = () => {
  return (
    <Row>
      <Col xxl="8" xl="6">
        <h5 className="f-w-700 mb-2">{SearchPixelStrap}</h5>
        {SearchLinkLists.map((item, i) => (
          <InformationBlock item={item} key={i} />
        ))}
      </Col>
      <SearchBanner />
      <PaginationCard pageClass="end" />
    </Row>
  );
};

export default AllTabs;
